import { common as commonBackend } from '@/api'
import { account as backend } from '@/api'
import { findIndex } from 'lodash'

export default {

  namespaced: true,

  state: {
    account: {
      subscription: {
        type: {}
      },
      cards: []
    }
  },

  mutations: {
    setAcount: (state, payload) => state.account = payload,
    deleteCard: (state, cardId) => {
      let index = findIndex(state.account.cards, card => card.id === cardId)

      state.account.cards.splice(index, 1)
    }
  },

  actions: {
    loadAccount: ({commit}) => new Promise((resolve, reject) => {
      commonBackend.loadPath({
        path: '/account/billing'
      }, response => {
        commit('setAcount', response.data)
        resolve()
      }, error => reject(error))
    }),
    deleteCard: ({commit}, cardId) => new Promise((resolve, reject) => {
      backend.deleteCard(cardId, response => {
        commit('setAcount', response.data)
        resolve()
      }, error => reject(error))
    })
  },

  getters: {
    account: state => state.account,
  }
}
